<template>
    <div>
        <el-menu-item
            :index="`/${item.path}`"
            v-if="item.children == 0 || item.children == null"
            @click='$store.state.title = item.title'
        >
            <i class="el-icon-caret-right"></i>
            {{ item.title && item.title }}
        </el-menu-item>
        <el-submenu v-else :index="item.id.toString()">
            <template slot="title">
                <i class="el-icon-caret-right"></i>
                {{ item.title && item.title }}
            </template>
            <template v-for="(child, indes) in item.children">
                <menu-item :item="child" :key="indes"></menu-item>
            </template>
        </el-submenu>
    </div>
</template>

<script>
export default {
    name: "menuItem",
    props: ["item"],
    data() {
        return {}
    },
}
</script>

<style lang='less'>
.el-menu-item, .el-submenu__title {
  font-size: 16px !important;
  color: #666666 !important;
}

.el-menu-item.is-active,.el-submenu__title:hover {
  color: #3875FF !important;
  background: transparent !important;
}
</style>
